import { type FC, useCallback, memo } from "react";

import { translationsLV, translationsRU } from "../translations/textTranslations";
import type { Language } from "../types";

import './SelectLanguage.css';

export let translations = translationsLV;

interface SelectLanguageProps {
    setLanguage: (valoda: Language) => void;
    setIsLanguageSelected: (vaiIrIzveletaValoda: boolean) => void;
}

export const SelectLanguage: FC<SelectLanguageProps> = memo(({ setLanguage, setIsLanguageSelected }) => {
    const handleClick = useCallback((language: Language)=>{
        setLanguage(language);
        setIsLanguageSelected(true);
        if (language === "ru") {
            translations = translationsRU;
        } else {
            translations = translationsLV;
        }
    },[setLanguage, setIsLanguageSelected]);
    
    return (
        <div className="selectLanguageContainer">
            <div className="selectLanguageTitle">Izvēlies valodu</div>
            <div className="languageContainer">
                <div className="bubble" onClick={() => handleClick("lv")}>
                    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                        <path d="M61.2 39V25C58 11.8 46.2 2 32 2S6 11.8 2.8 25v14C6 52.2 17.8 62 32 62s26-9.8 29.2-23" fill="#c94747" />
                        <path d="M61.2 39V25C58 11.8 46.2 2 32 2S6 11.8 2.8 25v14C6 52.2 17.8 62 32 62s26-9.8 29.2-23" opacity=".15" fill="#c28fef" />
                        <path d="M2 32c0 2.4.3 4.8.8 7h58.3c.5-2.2.8-4.6.8-7c0-2.4-.3-4.8-.8-7H2.8c-.5 2.2-.8 4.6-.8 7" fill="#ffffff" />
                    </svg>
                </div>
                <div className="bubble" onClick={() => handleClick("ru")}>
                    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                        <path d="M31.9 2c-13 0-24.1 8.4-28.2 20h56.6C56.1 10.4 45 2 31.9 2z" fill="#f9f9f9" />
                        <path d="M31.9 62c13.1 0 24.2-8.4 28.3-20H3.7c4.1 11.7 15.2 20 28.2 20z" fill="#ed4c5c" />
                        <path d="M3.7 22C2.6 25.1 2 28.5 2 32s.6 6.9 1.7 10h56.6c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10H3.7" fill="#428bc1" />
                    </svg>
                </div>
            </div>
        </div>
    )  
});
